import {ConfigState, initConfig, initLogger, sessionDataHandler, store} from ".";
import {merge} from "lodash";
import {PropsWithChildren, useEffect} from "react";
import {Provider} from "react-redux";
import {consumerAppBaseUrl} from "~/constants/defaultValues";
import WebchatWidget from "./components/WebchatWidget";

const defaultConfig: ConfigState = {
  serverUrl: consumerAppBaseUrl,
  theme: {
    isLight: true,
  },
  fileAttachment: {
    enabled: true,
    maxFileSize: 16777216,
    acceptedExtensions: ["jpg", "jpeg", "png", "amr", "mp3", "mp4", "pdf"],
  },
};

export const WebchatStoreProvider = ({children}: PropsWithChildren) => {
  return <Provider store={store}>{children}</Provider>;
};

export const Webchat = ({config}: {config?: ConfigState}) => {
  const mergedConfig = merge({}, defaultConfig, config);
  sessionDataHandler.setEndpoint(mergedConfig.serverUrl);
  initLogger();
  useEffect(() => {
    store.dispatch(initConfig(mergedConfig));
  }, []);
  return <WebchatWidget />;
};
